<div class="flex column justify-space-between root">
    <div class="flex column items">
        @for (annotation of annotations$ | async; track annotation) {
            <frog-annotation-list-item [annotation]="annotation"></frog-annotation-list-item>
        }

        <div>
            <mat-form-field appearance="fill">
                <mat-label>Add Annotation</mat-label>
                <textarea matInput [formControl]="contentControl"></textarea>
            </mat-form-field>

            <button mat-stroked-button color="primary" (click)="addComment()">Post Comment</button>
        </div>
    </div>
</div>
